import styled from 'styled-components'

export const Img = styled.img`
  width: 65px;
  height: 60px;
  color: #ffffff;
`
